import { useEffect, useState } from "react";
import { db } from "../shared/firebase";
import { useAppSelector } from "../store/hooks";
import { useQuery } from "@tanstack/react-query";
import { doc, onSnapshot } from "firebase/firestore";
import PageTitle from "../components/Common/PageTitle";
import { getMoviesGenresList, getTVGenresList } from "../services/home";
import ListViewForWatchlistAndHistory from "../components/ListViewForWatchlistAndHistory/ListViewForWatchlistAndHistory";
import Footer from "../components/Footer/Footer";

const History = () => {
  const currentUser = useAppSelector((state) => state.auth.user);
  const [recentlyWatchFilms, setRecentlyWatchFilms] = useState([]);
  const [isLoading, setIsLoading] = useState(
    !Boolean(recentlyWatchFilms.length)
  );
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (!currentUser) return;

    const unsubDoc = onSnapshot(
      doc(db, "users", currentUser?.uid),
      (doc) => {
        setRecentlyWatchFilms(doc.data()?.recentlyWatch.slice().reverse());
        setIsLoading(false);
      },
      (error) => {
        alert(error);
        setRecentlyWatchFilms([]);
        setIsLoading(false);
        setIsError(true);
      }
    );

    return () => unsubDoc();
  }, [currentUser]);

  const {
    data: moviesGenres,
    isLoading: isLoadingMoviesGenres,
    isError: isErrorMoviesGenres,
    error: errorMoviesGenres,
  } = useQuery(["movies-genres"], getMoviesGenresList);

  const {
    data: tvGenres,
    isLoading: isLoadingTVGenres,
    isError: isErrorTVGenres,
    error: errorTVGenres,
  } = useQuery(["tv-genres"], getTVGenresList);

  // GENRES

  if (isErrorMoviesGenres) return <p>ERROR: ${errorMoviesGenres.message}</p>;

  if (isLoadingMoviesGenres) return <p>Loading...</p>;

  if (isErrorTVGenres) return <p>ERROR: ${errorTVGenres.message}</p>;

  if (isLoadingTVGenres) return <p>Loading...</p>;

  if (isError) return <div>ERROR</div>;

  return (
    <>
      <PageTitle value="History | SHWETFLIX" />
      <ListViewForWatchlistAndHistory
        films={recentlyWatchFilms}
        isLoading={isLoading}
        pageType="history"
        genresList={{ ...moviesGenres, ...tvGenres }}
      />
      <Footer />
    </>
  );
};

export default History;
